import { PageHeader } from "@design-system/components";
import { GovernanceAndRegulatoryDocuments } from "../components";
import { investorGovernanceDocumentsBreadcrumb } from "../data";
import { DocumentFile } from "../types";

type InvestorGovernanceDocumentsPageProps = {
  documents: DocumentFile[];
};

export function InvestorGovernanceDocumentsPage({
  documents,
}: InvestorGovernanceDocumentsPageProps) {
  return (
    <>
      <PageHeader
        translationKey="governanceDocuments"
        breadcrumbItems={investorGovernanceDocumentsBreadcrumb}
      />

      <GovernanceAndRegulatoryDocuments documents={documents} />
    </>
  );
}
